import React, { ReactNode } from 'react';
import { Popover, IconButton } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';

interface IInfoPopoverProps {
  iconSize: string;
  title?: string;
  children: ReactNode;
  placement?: Placement;
  onIconClick?: () => void;
}

type Placement =
  | 'top-start'
  | 'top'
  | 'top-end'
  | 'left'
  | 'right'
  | 'bottom-start'
  | 'bottom'
  | 'bottom-end';

export const InfoPopover = ({
  iconSize,
  title,
  children,
  placement = 'bottom',
  onIconClick,
}: IInfoPopoverProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    onIconClick?.();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? `${placement}-popover` : undefined;

  const Icon = () => (
    <InfoFilled size={iconSize} color="info" aria-label="infoIcon" />
  );

  return (
    <div className="sui-outline-0 sui-inline sui-pt-4">
      <IconButton
        aria-describedby={id}
        onClick={handleClick}
        icon={Icon}
        size={iconSize}
        aria-label="infoButton"
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        placement={placement}
        title={title}
      >
        {children}
      </Popover>
    </div>
  );
};
